var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppendments } from '../hooks';
import { MultiLineReadOnly } from 'shared/components/features/Form/MultiLineReadOnly';
import { Box, Heading, Text, Divider } from 'shared/components/ui';
import { formatFullDateTime } from 'shared/utils';
export var NoteHistory = function (_a) {
    var _b;
    var noteId = _a.noteId, noteSignedAt = _a.noteSignedAt, visible = _a.visible;
    var appendments = useAppendments(noteId);
    if (!visible)
        return null;
    return (_jsxs(_Fragment, { children: [(_b = appendments === null || appendments === void 0 ? void 0 : appendments.data) === null || _b === void 0 ? void 0 : _b.map(function (a) {
                return (_jsxs(Box, __assign({ pl: 4, mb: 3 }, { children: [_jsx(Heading, __assign({ "data-testid": "noteAppended", size: "h4" }, { children: "Note appended" })), _jsx(MultiLineReadOnly, { "data-testid": 'noteAppended-readonly', text: a.appendment }), _jsx(Text, __assign({ size: "small" }, { children: formatFullDateTime(a.signedAt) }))] }), a.id));
            }), _jsxs(Box, __assign({ pl: 4 }, { children: [_jsx(Heading, __assign({ size: "h4" }, { children: "Note signed" })), _jsx(Text, __assign({ size: "small" }, { children: noteSignedAt && formatFullDateTime(noteSignedAt) }))] })), _jsx(Divider, { my: 3 })] }));
};
